import { render, staticRenderFns } from "./UploadRepairDocs.vue?vue&type=template&id=e18b4de6&"
import script from "./UploadRepairDocs.vue?vue&type=script&lang=js&"
export * from "./UploadRepairDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports